/**
 * **RezTrip by Travel Tripper**
 *
 * @exports bs_121
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let rezTripChange;
    engine._isMobile = function () {
        return window.location.pathname.substr(0, 7) === '/mobile';
    };
    /**
       * @memberOf module:bs_121
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 500);
    };
    /**
     * @memberOf module:bs_121
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.includes('reztrip');
        if (!validUrl) {
            return ctx;
        }
        url.pathname = 'search';
        const params = new URLSearchParams();
        params.append('arrival_date', '[date_begin]');
        params.append('departure_date', '[date_end]');
        params.append('adults[]', '[adults]');
        params.append('children[]', '[children]');
        params.append('currency', '[currency]');
        params.append('locale', '[language]');
        url.search = params.toString();
        ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/\//g, '-');
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * @memberOf module:bs_121
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux = window.location.pathname.match(/^\/classic\/(\w{2})/i);
            aux = aux && aux.length && aux[1];
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            reject('no_language');
        });
    };
    /**
     * @memberOf module:bs_121
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = !document.querySelector('#signIn_btn');
        return isLogged;
    };
    /**
       * @memberOf module:bs_121
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const $ = window.jQuery;
        // If jQuery is not available
        // or the observer is already set
        // or we're visiting the mobile page
        if (!$ || thn.onReztripClick || engine._isMobile()) {
            return;
        }
        thn.onReztripClick = function onReztripClick() {
            // IMPORTANT NOTE: this app deletes ALL of the DOM, thus observers,
            // widgets, etc must be destroyed and regenerated
            // remove old observer
            if (thn.reztripUpdate) {
                // remove the observer
                thn.stopObserveDom($('html').get(0), thn.reztripUpdate);
                delete thn.reztripUdpate;
            }
            // define a new update function
            thn.reztripUpdate = thn.debounce(function thnReztripUpdate() {
                const $loader = $('#loading');
                ctx.widget.logger.debug('*************** DOM Changed **************');
                // once the loader is not visible
                if ($loader.length && !$loader.is(':visible')) {
                    // remove the observer
                    thn.stopObserveDom($('html').get(0), thn.reztripUpdate);
                    delete thn.reztripUdpate;
                    // then update ...
                    thn.languageCheck().then(function ({ changed }) {
                        if (!changed) {
                            // reset PW
                            thn.widgets.price.reset().destroy().init();
                        }
                    });
                }
            }, 400);
            // start observation on loader
            thn.observeDom($('html').get(0), thn.reztripUpdate, {
                subtree: false,
            });
            // exec now
            thn.reztripUpdate();
        }; // on_reztrip_click
        $(document).on('click', '.search-form-submit .button, .button.submit', thn.onReztripClick);
        thn.pageUnload(function () {
            $(document).off('click', '.search-form-submit .button, .button.submit', thn.onReztripClick);
            delete thn.onReztripClick;
        });
        const container = document.body;
        if (container && !rezTripChange) {
            rezTripChange = thn.debounce(() => {
                const loader = document.querySelector('.la-ball-spin-clockwise-fade-rotating, body.modal-open');
                if (!loader) {
                    thn.widgets.price.refresh();
                }
            }, 800);
            thn.observeDom(container, rezTripChange, {
                childList: true,
                subTree: true,
                attributes: true,
            });
            thn.pageUnload(() => {
                rezTripChange.cancel();
                thn.stopObserveDom(container, rezTripChange);
                rezTripChange = null;
            });
        }
    };
    /**
       * @memberOf module:bs_121
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // IMPORTANT: DO NOT forbid PW execution
        // on promocode presence anymore. Please add exceptions for
        // the problematical codes/hotels when needed.
        const promocodeBlacklist = {
            PROM3: {
                propertyIds: [1014039],
            },
            TIPSY: {
                propertyIds: [1014039],
            },
            PAI: {
                propertyIds: [1014543],
            },
            SUMZAI: {
                propertyIds: [1014543],
            },
            RPKG: {
                propertyIds: [1014543],
            },
            DREAMY: {
                propertyIds: [1014543],
            },
            WTK: {
                propertyIds: [1024378],
            },
            WTKA: {
                propertyIds: [1024378],
            },
            WTD: {
                propertyIds: [1024378],
            },
            BTK: {
                propertyIds: [1024378],
            },
            GLD: {
                propertyIds: [1024378],
            },
            WSSK: {
                propertyIds: [1024378],
            },
            GTK: {
                propertyIds: [1024378],
            },
        };
        const { promocode } = ctx.widget.getPromocode();
        // list here hotels which must NOT show PW with promocode presence
        const isPromocodeBlacklisted = Object.keys(promocodeBlacklist).some(function (pattern) {
            const value = promocodeBlacklist[pattern];
            return !!(
            // The promocode matches the blacklist pattern
            promocode.match(new RegExp(pattern))
                && (
                // Or it is a "global" pattern
                thn.empty(value)
                    // Or the pattern applies to this property
                    || value.propertyIds.includes(thn.data.propertyId)));
        });
        if (promocode // promocode presence AND
            && isPromocodeBlacklisted // OR the promocode is blacklisted
        ) {
            // Do not execute PW at all
            this.logger.debug('Detected a promocode or rate: avoid PW comparison');
            return widgetData;
        }
        if (engine._isMobile()) {
            widgetData.dateBegin = (window.sd || '').replace(/-/g, '/');
            widgetData.dateEnd = (window.ed || '').replace(/-/g, '/');
            widgetData.adults = parseInt(window.na, 10) || 2;
            widgetData.children = parseInt(window.nc, 10) || 0;
            widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
            widgetData.rooms = parseInt(window.nr, 10) || 1;
            widgetData.currency = window.cc;
            const prices = [];
            if (document.getElementsByClassName('card_price-actual')) {
                const pricesSelector = document.querySelectorAll('strong.card_price-actual.text-medium.text-lg.move-left.rm-rate.-theme-color');
                for (let i = 0; i < pricesSelector.length; i += 1) {
                    prices.push(thn.parseNumber(pricesSelector[i].innerText));
                }
            }
            let signalCurrency;
            if (window.cc) {
                signalCurrency = window.cc;
            }
            if (prices.length && signalCurrency) {
                widgetData.price = Math.min(...prices); // price is per night
                widgetData.currency = thn.getCurrencyCode(signalCurrency);
                widgetData.set = true;
            }
            else if ($('#errorAlertPopup:visible').length) {
                widgetData.noRooms = true;
            }
            return widgetData;
        } // Desktop
        // Searches can be for more than one room
        // but only one is shown at the same time on the screen
        widgetData.rooms = 1;
        // Pick guests of the first room
        widgetData.adults = thn.parseNumber(thn.parseUrlParameter('Adults_1')) || thn.parseNumber(document.querySelector('#adults-in-room-1')?.value) || 2;
        widgetData.children = thn.parseNumber(thn.parseUrlParameter('Children_1')) || thn.parseNumber(document.querySelector('#children-in-room-1')?.value) || 0;
        // Upfront select currency from URL
        widgetData.currency = thn.parseCurrency(thn.parseUrlParameter('currency')) || thn.parseCurrency(thn.parseUrlParameter('Currency')) || thn.parseCurrency(document.querySelector('#curr-dropdown')?.textContent);
        // When the quoteList object does exist, trust it
        if (window.quoteList && !thn.empty(window.quoteList)) {
            widgetData.price = Number.MAX_VALUE;
            widgetData.dateBegin = (window.quoteList[0].sd || '').replace(/-/g, '/');
            widgetData.dateEnd = (window.quoteList[0].ed || '').replace(/-/g, '/');
            window.quoteList.forEach(function (quote) {
                // price is per_night already
                const price = thn.parseNumber(quote.lr);
                if (price < widgetData.price) {
                    widgetData.price = price;
                    // If guests where not detected
                    // fallback to the guests in the cheapest room
                    if (thn.empty(widgetData.adults)) {
                        widgetData.adults = quote.na;
                    }
                    if (thn.empty(widgetData.children)) {
                        widgetData.children = quote.nc;
                    }
                }
            });
            // Reset price if something was wrong
            if (widgetData.price === Number.MAX_VALUE) {
                widgetData.price = undefined;
            }
            else {
                widgetData.set = true;
            }
            // Trust currency from quoteList over the URL
            widgetData.currency = window.quoteList[0].cc;
        }
        else {
            // Alternatively do a classic DOM parsing (legacy)
            const nightsFromParam = thn.parseNumber(thn.parseUrlParameter('LOS'));
            const dateBeginFromParam = thn.dateToString(thn.parseUrlParameter('CheckinDate')?.replace(/-/g, '/'));
            const dateEndFromParam = dateBeginFromParam && nightsFromParam && thn.dateToString(thn.addDays(dateBeginFromParam, nightsFromParam));
            const datesFromDOM = [...document.querySelectorAll('#r_checkin_summary_desktop span')].map((dateEl) => dateEl?.textContent);
            const dateBeginFromDOM = datesFromDOM.length === 2 && datesFromDOM[0].replace(/-/g, '/');
            const dateEndFromDOM = datesFromDOM.length === 2 && datesFromDOM[1].replace(/-/g, '/');
            const dateBeginFromInput = document.querySelector('input[name="search[arrival_date]"]')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            const dateEndFromInput = document.querySelector('input[name="search[departure_date]"]')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            widgetData.dateBegin = dateBeginFromDOM || dateBeginFromParam || dateBeginFromInput;
            widgetData.dateEnd = dateEndFromDOM || dateEndFromParam || dateEndFromInput;
            if (widgetData.dateBegin && widgetData.dateEnd) {
                if (document.querySelector('.rooms_price, .room-price')) {
                    const pricesSelector = document.querySelectorAll('span.rooms_price strong.ng-binding, .pricePanel .price');
                    const prices = [...pricesSelector].map((priceEl) => thn.parseNumber(priceEl?.textContent)).filter(Boolean);
                    if (prices.length && widgetData.currency) {
                        widgetData.price = Math.min(...prices); // price is per night
                        widgetData.set = true;
                    }
                }
            }
        }
        // If price remains empty, this might be a noRooms
        if (thn.empty(widgetData.price)
            && $('[ng-hide="showRoomInfo"]:visible').length) {
            widgetData.noRooms = true;
        }
        if ((typeof widgetData.adults !== 'undefined') && (typeof widgetData.children !== 'undefined')) {
            widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_121
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingId = thn.dataLayerHelper.get('cen_RezConfirmationID') || window.rtCONFIRMATIONNUMBER_0;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        const priceWithoutTax = thn.dataLayerHelper.get('ecommerce.purchase.actionField.revenue');
        const tax = thn.dataLayerHelper.get('ecommerce.purchase.actionField.tax');
        const totalPrice = priceWithoutTax + tax;
        widgetData.bookingId = bookingId;
        widgetData.price = window.rtTOTALCOSTWITHTAXES || totalPrice;
        widgetData.currency = thn.dataLayerHelper.get('cen_RezCurrency') || window.rtCURRENCYCODE;
        widgetData.dateBegin = (window.rtARRIVAL_0 || thn.dataLayerHelper.get('cen_RezArrivalDate'))?.replace(/-/g, '/');
        widgetData.dateEnd = (window.rtDEPARTURE_0 || thn.dataLayerHelper.get('cen_RezDepartureDate'))?.replace(/-/g, '/');
        widgetData.rooms = window.rtNUMROOMS || thn.dataLayerHelper.get('cen_RezRooms');
        widgetData.adults = window.rtADULTS_0 || thn.dataLayerHelper.get('cen_RezAdults');
        widgetData.children = window.rtCHILDREN_0 || thn.dataLayerHelper.get('cen_RezChildren');
        widgetData.promocode = thn.dataLayerHelper.get('cen_RezRoomTypeCode') || window.promo_code;
        return widgetData;
    };
    /**
       * @memberOf module:bs_121
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = thn.dataLayerHelper.get('cen_RezPromoCode') || thn.parseUrlParameter('offer_code');
        ctx.promocode = promocode || '';
        return ctx.promocode;
    };
    return engine;
}

export { factory };
